import angular from 'angular';
import accountSettingsModule from '../accountSettingsModule';

function accountSettingsModalPinUnlockController(
  $scope,
  $log,
  $uibModalInstance,
  accountsService,
  modalData
) {
  'ngInject';

  angular.extend($scope, modalData);
  $scope.pinInfo = {};

  $scope.pinErrorMessage = function(form) {
    if (form.$pristine && $scope.error) {
      return $scope.error;
    }
    return null;
  };

  $scope.submit = function(form) {
    if (form.$valid) {
      form.$setPristine();
      $scope.error = '';
      accountsService.beginUnlockAccountPinSetting($scope.pinInfo.pin).then(
        function(result) {
          $uibModalInstance.close(result);
        },
        function(error) {
          $scope.error = accountsService.getPinErrorMessageFromCode(error);
        }
      );
    }
  };
}

accountSettingsModule.controller(
  'accountSettingsModalPinUnlockController',
  accountSettingsModalPinUnlockController
);

export default accountSettingsModalPinUnlockController;
